const PERMISSION_KEY= "community:featured_content";
const PAGE_URL = {
    FEATURED_CONTENT_PAGE: "/admin/community/featured-content"
}

export {PERMISSION_KEY, PAGE_URL}

